import { render, staticRenderFns } from "./V1Client.vue?vue&type=template&id=7284d192&scoped=true&"
import script from "./V1Client.vue?vue&type=script&lang=js&"
export * from "./V1Client.vue?vue&type=script&lang=js&"
import style0 from "./V1Client.vue?vue&type=style&index=0&id=7284d192&scoped=true&lang=css&"
import style1 from "./V1Client.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284d192",
  null
  
)

export default component.exports